export default () => ({
    succes: false,
    formData: {},
    visitors: [],
    inviteData: {},
    visitor: null,
    error: null,
    qrPdf: null,
    create: true
});